import React from 'react'
import PropTypes from 'prop-types'
import { Page } from 'react-pdf'
import { FixedSizeList as FixedList, VariableSizeList } from 'react-window'

const PageView = ({
	numPages,
    width,
    height,
    pageHeights,
	scale,
	lazyLoad,
	handleResizeAndPageRender,
	pageIndex,
	signingBoxes
}) => {

	if (lazyLoad) {
		// Use VariableSizeList when we have individual heights per page, otherwise fallback to FixedList
		const ListComponent = pageHeights && pageHeights.length ? VariableSizeList : FixedList

		const itemSize = index => {
			if (pageHeights && pageHeights.length) {
				return pageHeights[index]
			}
			return height
		}

		return (
			<ListComponent
				itemCount={numPages}
				itemSize={pageHeights && pageHeights.length ? itemSize : height}
				width={width}
				height={height}
				style={{ overflowY: 'auto', overflowX: 'hidden' }}
			>
				{({ style, index }) => (
					<div style={style}>
						<Page
							key={`page_${index + 1}`}
							className="pdf-page-wrapper"
							pageNumber={index + 1}
							renderAnnotations={false}
							renderTextLayer={false}
							width={width}
							scale={scale}
							onRenderSuccess={handleResizeAndPageRender}
						>
							{signingBoxes[index]}
						</Page>
					</div>
				)}
			</ListComponent>
		)
	}

	// Non lazy load path
	return (
		<Page
			key={`page_${pageIndex}`}
			className="pdf-page-wrapper"
			pageNumber={pageIndex}
			renderAnnotations={false}
			renderTextLayer={false}
			width={width}
			scale={scale}
			onRenderSuccess={handleResizeAndPageRender}
		>
			{signingBoxes}
		</Page>
	)
}

PageView.propTypes = {
	width: PropTypes.number,
	height: PropTypes.number,
    pageHeights: PropTypes.array,
	scale: PropTypes.number,
	lazyLoad: PropTypes.bool,
	handleResizeAndPageRender: PropTypes.func
}

PageView.defaultProps = {
	pageIndex: null,
	signingBoxes: [],
	lazyLoad: false,
}

export default PageView